<template>
  <el-dropdown
    v-if="account.isAuthenticated"
    trigger="click"
    @command="command"
  >
    <el-button
      type="text"
      class="profile__button"
    >
      <div class="profile__button__body">
        <Avatar
          :username="account.blob.first_name + ' ' + account.blob.last_name"
          :src="account.blob.profile_image_url"
          :size="40"
        />
      </div>
    </el-button>

    <el-dropdown-menu
      slot="dropdown"
      class="profile__dropdown__name"
    >
      <el-dropdown-item>
        <span class="profile__dropdown__name__body"
        >{{ account.blob.first_name }}</span>
      </el-dropdown-item>
      <el-dropdown-item command="openProfile" divided>Profile</el-dropdown-item>
      <el-dropdown-item command="logout">Log out</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Avatar from 'vue-avatar';

export default {
  components: {
    Avatar,
  },
  data() {
    return {
    };
  },
  methods: {
    logout() {
      this.$store.dispatch('account/logout');
    },
    openProfile() {
      this.$router.push('/profile');
    },
    command(event) {
      const fn = this[event];
      if (typeof fn === 'function') {
        fn();
      }
    },
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};
</script>

<style lang="scss">
$dropdown-width: 160px;
$dropdown-padding-x: 20px;

.profile__button__body {
  display: flex;
  justify-content: center;
  align-items: center;
}
.profile__name {
  padding: 1em 0.5em;
}
.profile__dropdown__name {
  width: $dropdown-width;
}
.profile__dropdown__name__body {
  white-space: nowrap;
  width: calc(#{$dropdown-width} - (2 * #{$dropdown-padding-x}));
  overflow: hidden;
  line-height: 1;
  display: inline-block;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation/ProfileDropdown.vue